import React from 'react'
import Img from "gatsby-image"
import { useStaticQuery, graphql } from "gatsby"

import Image from '../components/Image'
import Layout from '../components/Layout'
import Paper from '../components/Paper'
import SEO from '../components/Seo'
import Typography from '../components/Typography'

import compStyles from '../pageComponents/aboutUs/aboutUs.module.scss'

const AboutUs = (props) => {
  const images = useStaticQuery(graphql`
    query {
      administration: allFile(filter: {extension: {regex: "/(jpg)|(jpeg)|(png)/"}, relativeDirectory: {eq: "admins"}}) {
        edges{
          node{
            base
              childImageSharp {
                fluid(quality: 100, maxWidth: 240) {
                  ...GatsbyImageSharpFluid
                }
              }
          }
        }
      },
      members: allFile(filter: {extension: {regex: "/(jpg)|(jpeg)|(png)/"}, relativeDirectory: {eq: "members"}}) {
        edges{
          node{
            base
              childImageSharp {
                fixed(width: 180) {
                  ...GatsbyImageSharpFixed
                }
              }
          }
        }
      },
      president: file(relativePath: { eq: "admin.png" }) {
        childImageSharp {
          fixed(width: 180 ) {
            ...GatsbyImageSharpFixed
          }
        }
      }
    }
  `)

  return (
  <Layout>
    <SEO title='ನಮ್ಮ ಬಗ್ಗೆ' />
    <Paper>
      <Typography variant="h2" id="adminMessage"  className={compStyles.about__heading}>ಅಧ್ಯಕ್ಷರ ಮನವಿ</Typography>
      <div className={compStyles.presidentMessage}>
        <div className={compStyles.president__details}>
          <Img fixed={images.president.childImageSharp.fixed} />
          <div>
            <Typography variant="h3" className={compStyles.about__heading}>ಎನ್. ಶ್ರೀಧರ್</Typography>
            <Typography variant="body1" className={compStyles.about__heading}>ಅಧ್ಯಕ್ಷರು</Typography>
          </div>
        </div>
        <div>
          <Typography variant="body1" className={compStyles.about__description}>
            ಸತ್ಯಂ ಶಿವಂ ಸೇವಾ ಸಂಸ್ಥೆಯು ಸಾಮಾಜಿಕ ಕಳಕಳಿಯನ್ನು ಪ್ರಧಾನ ಉದ್ದೇಶವಾಗಿಟ್ಟುಕೊಂಡು ರೂಪ ತಳೆದ ಒಂದು ಸಂಸ್ಥೆ. ಇದು, ಸಮಾಜದಲ್ಲಿ ಧರ್ಮಜಾಗೃತಿ, ಭಾಷೆ ಹಾಗೂ ಸಂಸ್ಕೃತಿಗಳ ಬಗ್ಗೆ ಅಭಿಮಾನ ಬೆಳೆಸುವ, ಸಮುದಾಯದಲ್ಲಿ ಬಡತನ, ಅಂಗವೈಕಲ್ಯ ಮೊದಲಾದ ಕಾರಣಗಳಿಂದ ನೊಂದ ಜೇವಿಗಳಿಗೆ ಸಹಾಯ ಒದಗಿಸುವ, ಬಡಮಕ್ಕಳ ಕಷ್ಟ ನೀಗಿಸುವ, ಪೌರರ ಹಕ್ಕುಗಳನ್ನು ಕಾಪಾಡುವ, ಸಾರ್ವಜನಿಕ ಸೌಲಭ್ಯಗಳ ನಿರ್ವಹಣೆಯನ್ನು ಸುಗಮಗೊಳಿಸುವ, ಗೋಶಾಲೆ, ಪ್ರಾಣಿ ಪಕ್ಷಿ ಮತ್ತು ಮರ ಗಿಡಗಳ ರಕ್ಷಣೆ ಒದಗಿಸುವ ಮಹತ್ವಾಕಾಂಕ್ಷೆಯನ್ನು ಹೊಂದಿದು . ಬನ್ನಿ, ನಮ್ಮ ನಿಮ್ಮ ಕನಸುಗಳನ್ನು ಸಾಕಾರಗೊಳಿಸಲು ನಮ್ಮೊಂದಿಗೆ ಕೈಜೋಡಿಸಿ. ನಮ್ಮ ಸಂಸ್ಥೆಯ ಸದಸ್ಯತ್ವ ಪಡೆದು ನಿಮ್ಮ ತನು ಮನ ಧನ ಸಹಾಯ ನೀಡಿ ಒಂದು ಉತ್ತಮ ಸಮುದಾಯವನ್ನು ರಚಿಸುವ ಉದಾತ್ತ ಕಾರ್ಯದಲ್ಲಿ ಭಾಗಿಯಾಗಿ.
          </Typography>
        </div>
      </div>
    </Paper>
    <div style={{ width: '100%', backgroundColor: '#f7f0e3' }}>
      <div className={compStyles.seperator} style={{ width: '300px', margin: 'auto' }}><Image imageName="border1"/></div>
    </div>
    <Paper>
      <Typography variant="h2" id="admins" className={compStyles.about__heading}>ಆಡಳಿತ ಮಂಡಳಿ</Typography>
      <div className={compStyles.administration}>
        {
          images.administration.edges.map(admin => {
            const i = admin.node.base.indexOf('.')
            const pos = admin.node.base.split(',')[0]
            const name = admin.node.base.substr(i + 1, admin.node.base.lastIndexOf('.') - i - 1)
            const nameAndPosition = name.split('-')
            return {
              image: admin,
              pos: parseInt(pos),
              name: nameAndPosition[0],
              position: nameAndPosition[1]
            }
          }).sort((a, b) => (a.pos - b.pos)).map( ({image, name, position}, index) => {
            return (<div key={index} className={compStyles.admin}>
              <Img className={compStyles.admin__image} fluid={image.node.childImageSharp.fluid} />
              <Typography variant="body1" className={compStyles.memberName}>{name}</Typography>
              <Typography variant="body1">{position}</Typography>
            </div>)
          })
        }
      </div>
    </Paper>
    <div style={{ width: '100%', backgroundColor: '#f7f0e3' }}>
      <div className={compStyles.seperator} style={{ width: '300px', margin: 'auto' }}><Image imageName="border1"/></div>
    </div>
    <Paper>
      <Typography variant="h2" id="members"  className={compStyles.about__heading}>ಸದಸ್ಯರು</Typography>
      <div className={compStyles.administration}>
        {
          images.members.edges.map( (member, index) => {
            const name = member.node.base.substr(0, member.node.base.lastIndexOf('.'))
            return (<div key={index} className={compStyles.member}>
              <Img fixed={member.node.childImageSharp.fixed} />
              <Typography variant="body1" className={compStyles.memberName}>{name}</Typography>
            </div>)
          })
        }
      </div>
    </Paper>
  </Layout>
  )
}

export default AboutUs
